import { render, staticRenderFns } from "./externalFileControlTable.vue?vue&type=template&id=c94fbb48&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./externalFileControlTable.vue?vue&type=style&index=0&id=c94fbb48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c94fbb48",
  null
  
)

export default component.exports